import * as React from 'react';
import { AppState } from '../classes/app-state';
import { Dispatch, connect } from 'react-redux';
import { favoritePage, unfavoritePage, toggleFavorite } from '../redux/actions';

import FavoritesStatus from './favorites-status';

interface IAppExternalProps {
}

interface IAppStateProps {
    pageKey: string;
    errorMessage: string;
    isLoggedIn: boolean;
}

interface IAppDispatchProps {
    toggleFavorite: () => any;
}

type IAppProps = IAppExternalProps & IAppStateProps & IAppDispatchProps;

interface IAppState {

}

export class App extends React.Component<IAppProps, IAppState> {
    onClick(evt: React.MouseEvent<MouseEvent>) {
        if (this.props.isLoggedIn) {
            this.props.toggleFavorite();
        }
    }

    private clickButton = this.onClick.bind(this);

    render() {
        let a11yDialog = {};

        if (!this.props.isLoggedIn) {
            a11yDialog = { "data-a11y-dialog-show": "login-modal" };
        }


        return (
            <React.Fragment>
                <button {...a11yDialog} className="favorites-trigger btn-text" onClick={this.clickButton} >
                    <FavoritesStatus />
                </button>
                <label className={"field-validation-error " + (this.props.errorMessage ? null : "hidden")}>There was an error saving your selection.</label>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: IAppExternalProps): IAppStateProps {
    return {
        isLoggedIn: state.favoritesState.isLoggedIn,
        pageKey: state.favoritesState.pageKey,
        errorMessage: state.apiState.error
    }
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: IAppExternalProps): IAppDispatchProps {
    return {
        toggleFavorite: () => dispatch(toggleFavorite())
    }
}

export default connect<IAppStateProps, IAppDispatchProps>(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/components/app.tsx